export default "__VITE_PUBLIC_ASSET__9996c22e__"